import { Grid, Table, TableBody, TableCell, TableRow } from "@material-ui/core";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useRouteMatch } from "react-router-dom";

import { DetailTable } from "../../../../components/detail_table";
import { IAsyncData, isNullish } from "../../../../core/models";
import { IAppReduxState } from "../../../../redux/store";
import { calcCleanWeight } from "../../../product/utils";
import { ITransaction } from "../../data/entities";
import { transactionTypeToString } from "../../data/models";
import { transactionRedux } from "../state/state";

export const TransactionDetailPage: React.FC = () => {
  const match = useRouteMatch<{ id: string }>();
  const { id } = match.params;
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(transactionRedux.actions.getDetail(id));
  }, [dispatch, id]);
  const transactionDetailBranch = useSelector<IAppReduxState, IAsyncData<ITransaction>>(
    (state) => state.transaction.details,
  );

  return (
    <Grid container justify="center">
      <Grid item md={8} lg={6}>
        <DetailTable branch={transactionDetailBranch}>
          <Table size="medium" className="detail-table">
            <TableBody>
              {transactionDetailBranch.data && (
                <>
                  <TableRow>
                    <TableCell>Klient</TableCell>
                    <TableCell>{transactionDetailBranch.data?.client?.name}</TableCell>
                  </TableRow>

                  <TableRow>
                    <TableCell>Tip</TableCell>
                    <TableCell>{transactionTypeToString(transactionDetailBranch.data?.type)}</TableCell>
                  </TableRow>

                  {transactionDetailBranch.data.expense && (
                    <TableRow>
                      <TableCell>Xerc adi</TableCell>
                      <TableCell>{transactionDetailBranch.data.expense?.name}</TableCell>
                    </TableRow>
                  )}

                  {transactionDetailBranch.data?.product && (
                    <TableRow>
                      <TableCell>Mal</TableCell>
                      <TableCell>{transactionDetailBranch.data?.product.name}</TableCell>
                    </TableRow>
                  )}

                  <TableRow>
                    <TableCell>Toplam qiymet</TableCell>
                    <TableCell>{transactionDetailBranch.data?.amount} AZN</TableCell>
                  </TableRow>

                  {!isNullish(transactionDetailBranch.data?.dirtyWeight) &&
                    !isNullish(transactionDetailBranch.data?.wastePercent) && (
                      <TableRow>
                        <TableCell>Orta qiymet</TableCell>
                        <TableCell>
                          {transactionDetailBranch.data.amount /
                            calcCleanWeight({
                              dirtyWeight: transactionDetailBranch.data.dirtyWeight,
                              wastePercent: transactionDetailBranch.data.wastePercent ?? 0,
                            })}{" "}
                          AZN
                        </TableCell>
                      </TableRow>
                    )}

                  {!isNullish(transactionDetailBranch.data?.dirtyWeight) && (
                    <TableRow>
                      <TableCell>Cirkli ceki</TableCell>
                      <TableCell>{transactionDetailBranch.data?.dirtyWeight} kq</TableCell>
                    </TableRow>
                  )}

                  {!isNullish(transactionDetailBranch.data?.dirtyWeight) &&
                    !isNullish(transactionDetailBranch.data?.wastePercent) && (
                      <TableRow>
                        <TableCell>Temiz ceki</TableCell>
                        <TableCell>
                          {calcCleanWeight({
                            dirtyWeight: transactionDetailBranch.data.dirtyWeight,
                            wastePercent: transactionDetailBranch.data.wastePercent,
                          })}{" "}
                          kq
                        </TableCell>
                      </TableRow>
                    )}

                  {!isNullish(transactionDetailBranch.data?.wastePercent) && (
                    <TableRow>
                      <TableCell>Itki faizi</TableCell>
                      <TableCell>{transactionDetailBranch.data?.wastePercent} %</TableCell>
                    </TableRow>
                  )}

                  {/* {!isNullish(transactionDetailBranch.data?.wastePercent) && (
                    <TableRow>
                      <TableCell>Itki faizi</TableCell>
                      <TableCell>{transactionDetailBranch.data} %</TableCell>
                    </TableRow>
                  )} */}

                  {transactionDetailBranch.data?.income && (
                    <TableRow>
                      <TableCell>Qazanc</TableCell>
                      <TableCell>{transactionDetailBranch.data?.income} AZN</TableCell>
                    </TableRow>
                  )}

                  <TableRow>
                    <TableCell>Tarix</TableCell>
                    <TableCell>{transactionDetailBranch.data?.createdDate.toDateString()}</TableCell>
                  </TableRow>
                </>
              )}
            </TableBody>
          </Table>
        </DetailTable>
      </Grid>
    </Grid>
  );
};
